import type { App } from 'vue'
import { registerComponents } from './components'

export * from './markdown'

// Shared by the brand profile (FR-B5), the campaign brief (FR-C4) and the copy document (FR-D1), so it sits at `src/` root.
export const createMarkdown = () => ({
  install: (app: App) => registerComponents(app)
})
